module.exports = __webpack_public_path__ + "img/Lacerta.7a10b315.png";